@if (errorMessage) {
  <div class="h-screen w-full flex items-center justify-center pb-page-bottom">
    <p class="p-5 md:px-8 font-normal text-base md:text-3xl text-error-700 text-center">
      {{ errorMessage | translate }}
    </p>
  </div>
}
